import { render } from "./NotificationsMenu.vue?vue&type=template&id=09913bd4"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script